import { initUiEvents } from '@jumpcloud/ui-events';
import { createEventsMixin } from './EventsMixin';
export const EventsPlugin = {
    install(Vue, options) {
        initUiEvents(options);
        Vue.mixin(createEventsMixin(options));
    },
};
//# sourceMappingURL=EventsPlugin.js.map